import React, { PropTypes } from 'react';
import Money from 'common/components/money';
import { UNLIMITED_FOCUS_GROUPS } from 'pap/constants';

const Upgrade = ({ project, toggleFeaturesModal }) => {
  const feature = project.features.find(f => f.feature.name == UNLIMITED_FOCUS_GROUPS);

  if (project.can_create_focus_group || !feature) {
    return null;
  }

  return (
    <div className="focus-group-upgrade">
      <h4>Need more focus groups?</h4>
      <p>
        Upgrade to unlimited public and/or private focus groups
        for <Money value={feature.feature.price} />.
      </p>
      <button className="btn btn-primary" onClick={toggleFeaturesModal}>Upgrade</button>
    </div>
  );
}

Upgrade.propTypes = {
  project: PropTypes.object.isRequired,
  toggleFeaturesModal: PropTypes.func.isRequired,
};

export default Upgrade;



// WEBPACK FOOTER //
// ./focus_groups/components/upgrade.jsx